var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_542_211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.375 4.0625C9.28594 4.0625 7.24379 4.68198 5.50679 5.8426C3.7698 7.00322 2.41598 8.65286 1.61653 10.5829C0.817077 12.513 0.607904 14.6367 1.01546 16.6856C1.42302 18.7346 2.429 20.6166 3.90619 22.0938C5.38338 23.571 7.26544 24.577 9.31436 24.9845C11.3633 25.3921 13.4871 25.1829 15.4171 24.3835C17.3471 23.584 18.9968 22.2302 20.1574 20.4932C21.318 18.7562 21.9375 16.7141 21.9375 14.625H11.375V4.0625Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.625 0.8125V11.375H25.1875C25.1875 9.98791 24.9143 8.61441 24.3835 7.33291C23.8527 6.0514 23.0746 4.887 22.0938 3.90618C21.113 2.92537 19.9486 2.14734 18.6671 1.61652C17.3856 1.08571 16.0121 0.8125 14.625 0.8125V0.8125Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_542_211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.3ab8c5e26e870d5ae2d0ee483ce257e1.svg";
export { ForwardRef as ReactComponent };